import {CALCULATOR_ERRORS} from '../constants/calculatorErrors';

const sendEmail = async ({
  email,
  percent,
  male = false,
  locale = 'intl'
}) => {
  return fetch("/api/send-calculator", {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(
      { email, percent, male, locale }
    ),
  })
    .then((response) => response.text())
    .then((result) => {
      const message = JSON.parse(result).message;
      const isSuccessResponse =
        message === CALCULATOR_ERRORS.API_MESSAGE_SUCCESS;
      const type = isSuccessResponse ? "success" : "error";

      return type;
    })
    .catch((error) => {
      console.error(error);
    });
};

export default sendEmail;
